import React, { useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { Link as MUILink } from '@mui/material'
import { makeStyles } from 'tss-react/mui'

import SdsDocumentIcon from '@src/icons/SdsDocIcon'
import SDSModal from '@src/components/SDSModal'

const useStyles = makeStyles()((theme) => ({
  triggerLink: {
    fontSize: '14px',
    fontFamily: 'inherit',
    fontWeight: 'inherit',
    lineHeight: 'inherit',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  linkContent: {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    whiteSpace: 'nowrap',
    fontWeight: theme.typography.fontWeightBold,
    fontSize: theme.typography.pxToRem(16),
    color: theme.palette.primary.main,
    '&:hover': {
      cursor: 'pointer',
      color: theme.palette.primary.dark,
    },
  },
  linkIconContainer: {
    display: 'flex',
    height: 18,
    width: 18,
    fontSize: theme.typography.pxToRem(18),
    marginRight: theme.spacing(2),
  },
}))

const NewSrpSdsLink = ({ productNumber, brandKey, sdsLanguages }) => {
  const { classes, cx } = useStyles()

  // Convert object array to locale string array of unique upper case values
  const languageArray = sdsLanguages.map(
    (item) => item.locale.toUpperCase().split('_')[0]
  )
  const uniqueLanguages = [...new Set(languageArray)]

  const SDSLinkTrigger = () => (
    <span className={classes.linkContent}>
      <span className={classes.linkIconContainer}>
        <SdsDocumentIcon data-testid="sds-icon" />
      </span>
      <FormattedMessage id="SDS" defaultMessage="SDS" />
    </span>
  )

  const [sdsModalOpen, setSdsModalOpen] = useState(false)

  return (
    <>
      <MUILink
        component="button"
        data-testid={`sds-${brandKey}${productNumber}`}
        id={`sds-${brandKey}${productNumber}`}
        aria-describedby="sds"
        onClick={(e) => {
          e.preventDefault()
          setSdsModalOpen(true)
        }}
        color={'secondary'}
        className={cx(classes.triggerLink)}
        tabIndex={0}
      >
        <SDSLinkTrigger />
      </MUILink>
      <SDSModal
        open={sdsModalOpen}
        setModalOpen={setSdsModalOpen}
        brands={[brandKey]}
        productNumber={productNumber}
        sdsLanguages={uniqueLanguages as string[]}
      />
    </>
  )
}

export default NewSrpSdsLink
